import { H4, Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";

const ProfileHeader = () => {
  return (
    <div className="d-flex">
      <div className="d-flex-size-email">
        <Image className="rounded-circle me-3" src={dynamicImage(`user/user.png`)} alt="" />
      </div>
      <div className="flex-grow-1">
        <H4>{"MARK JENCO"}</H4>
        <P>{"Markjecno@gmail.com"}</P>
      </div>
    </div>
  );
};
export default ProfileHeader;
